import { render, staticRenderFns } from "./ReActivateRole.vue?vue&type=template&id=4385e7de"
import script from "./ReActivateRole.vue?vue&type=script&lang=js"
export * from "./ReActivateRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports